import styles from './Skills.module.css'
import { useEffect } from 'react';

import './skills-animations.css'
import SkillsSVG from '../../components/SVG/Skills/Skills'
import { animations, removeAnimation } from "../../scripts/animations"


import html from '../../images/skills/skills/html.svg';
import css from '../../images/skills/skills/css.svg';
import bootstrap from '../../images/skills/skills/bootstrap.svg';
import tailwind from '../../images/skills/skills/tailwind.svg';
import javascript from '../../images/skills/skills/js.svg';
import react from '../../images/skills/skills/react.svg';
import php from '../../images/skills/skills/php.svg';
import sql from '../../images/skills/skills/sql.svg';
import symfony from '../../images/skills/skills/symfony.svg';
import node from '../../images/skills/skills/node.svg';

import three from '../../images/skills/skills/three.svg';
import typescript from '../../images/skills/skills/typescript.svg';

export default function Skill({ visited }) {

    useEffect(() => {
        if (!visited) {
            animations(1200, '.group-skills');
        } else {
            removeAnimation('.group-skills');
        }
    }, [])

    return (
        <main className="main-vertical lg:gap-3" id="skills">
            <section className='text-section order-2 lg:order-1 section-vertical'>
                <h1 className='title group-skills toScale'>Compétences</h1>
                <div className={styles.skillsAbout}>
                    <div className={styles.skills}>
                        <div className={`${styles.skillsFront} group-skills hide`}>
                            <div className={`${styles.skillContainer} ${styles.basic}`}>
                                <div className={`${styles.skill}`}>
                                    <img src={html} alt="HTML" />
                                    <p>HTML</p>
                                </div>
                                <div className={`${styles.skill}`}>
                                    <img src={css} alt="CSS" />
                                    <p>CSS</p>
                                </div>
                            </div>
                            <div className={`${styles.skillContainer} ${styles.framework}`}>
                                <div className={styles.skill}>
                                    <img src={bootstrap} alt="Bootstrap" />
                                    <p>Bootstrap</p>
                                </div>
                                <div className={styles.skill}>
                                    <img src={tailwind} alt="Tailwind" />
                                    <p>Tailwind</p>
                                </div>
                            </div>
                            <div className={`${styles.skillContainer} ${styles.js}`}>
                                <div className={styles.skill}>
                                    <img src={javascript} alt="Javascript" />
                                    <p>Javascript</p>
                                </div>
                            </div>
                            <div className={`${styles.skillContainer} ${styles.react}`}>
                                <div className={styles.skill}>
                                    <img src={react} alt="React" />
                                    <p>React</p>
                                </div>
                            </div>
                        </div>
                        <div className={`${styles.skillsBack} group-skills hide`}>
                            <div className={styles.skillContainer}>
                                <div className={styles.skill}>
                                    <img src={php} alt="php" />
                                    <p>PHP</p>
                                </div>
                            </div>
                            <div className={styles.skillContainer}>
                                <div className={styles.skill}>
                                    <img src={sql} alt="SQL" />
                                    <p>SQL</p>
                                </div>
                            </div>
                            <div className={styles.skillContainer}>
                                <div className={styles.skill}>
                                    <img src={node} alt="Node.js" />
                                    <p>Node.js</p>
                                </div>
                            </div>
                            <div className={styles.skillContainer}>
                                <div className={styles.skill}>
                                    <img src={symfony} alt="Symfony" />
                                    <p>Symfony</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.learn} group-skills hide`}>
                        <div className={`flex-col ${styles.skillContainer}`}>
                            <h2 className={styles.learnTitle}>J'aimerais apprendre :</h2>
                            <div className={styles.learnSkillsContainer}>
                                <div className={styles.skill}>
                                    <img src={typescript} alt="Typescript logo" />
                                    <p>Typescript</p>
                                </div>
                                <div className={styles.skill}>
                                    <img src={three} alt="Three.js logo" />
                                    <p>Three.js</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <SkillsSVG visited={visited}></SkillsSVG>
        </main>
    )
}